export default function Footer() {
  return (
    <footer className="bg-dark-card text-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          {/* Logo et Description */}
          <div className="text-center sm:text-left">
            <img 
              src="https://public.readdy.ai/ai/img_res/d9accc10-e356-4e90-b05d-65db94bbda2f.png" 
              alt="LOUATI AUTOCENTER" 
              className="h-16 sm:h-20 w-auto object-contain mx-auto sm:mx-0 mb-4"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Excellence automobile à Payerne. Detailing premium et vente de véhicules d'exception.
            </p>
          </div>

          {/* Navigation */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-bold mb-4 text-white">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-white/80 hover:text-white transition-colors text-sm block py-1">
                  Accueil
                </a>
              </li>
              <li>
                <a href="/prestations" className="text-white/80 hover:text-white transition-colors text-sm block py-1">
                  Prestations
                </a>
              </li>
              <li>
                <a href="/vehicules" className="text-white/80 hover:text-white transition-colors text-sm block py-1">
                  Véhicules
                </a>
              </li>
              <li>
                <a href="/reservation" className="text-white/80 hover:text-white transition-colors text-sm block py-1">
                  Réservation
                </a>
              </li>
              <li>
                <a href="/entreprises" className="text-white/80 hover:text-white transition-colors text-sm block py-1">
                  Entreprises
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-bold mb-4 text-white">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start justify-center sm:justify-start gap-2">
                <i className="ri-map-pin-line text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-white/80 text-sm">
                  Z.I. Champ Cheval 2<br />
                  1530 Payerne
                </span>
              </li>
              <li>
                <a 
                  href="tel:+41796840588" 
                  className="flex items-center justify-center sm:justify-start gap-2 text-white/80 hover:text-white transition-colors text-sm min-h-[44px] sm:min-h-0 touch-manipulation"
                >
                  <i className="ri-phone-line text-lg"></i>
                  <span>+41 79 684 05 88</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:contact@louatiautocenter.ch" 
                  className="flex items-center justify-center sm:justify-start gap-2 text-white/80 hover:text-white transition-colors text-sm break-all min-h-[44px] sm:min-h-0 touch-manipulation"
                >
                  <i className="ri-mail-line text-lg flex-shrink-0"></i>
                  <span>contact@louatiautocenter.ch</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-bold mb-4 text-white">Horaires</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex justify-between sm:justify-start sm:gap-4 text-white/80">
                <span>Lun - Ven</span>
                <span className="font-semibold text-white">8h - 18h</span>
              </li>
              <li className="flex justify-between sm:justify-start sm:gap-4 text-white/80">
                <span>Samedi</span>
                <span className="font-semibold text-white">8h - 16h</span>
              </li>
              <li className="flex justify-between sm:justify-start sm:gap-4 text-white/80">
                <span>Dimanche</span>
                <span className="text-white/60">Fermé</span>
              </li>
            </ul>
            
            {/* Réseaux sociaux */}
            <div className="flex justify-center sm:justify-start gap-3 mt-6">
              <a
                href="https://wa.me/41796840588"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors touch-manipulation"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/louatiautocenter"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors touch-manipulation"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/louatiautocenter"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors touch-manipulation"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-8 sm:mt-12 pt-6 sm:pt-8 text-center">
          <p className="text-white/60 text-sm">
            © 2026 AUTOCENTRE LOUATI Sàrl. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}